<script setup lang="ts">
import {useAppUpdate} from "../composables/useAppUpdate";

const { needRefresh, update, close } = useAppUpdate()
</script>

<template>
  <div v-if="needRefresh" class="update-prompt">
    <div class="prompt-content">
      <div class="prompt-text">
        <i class="i-lucide-refresh-cw text-blue-600 w-5 h-5" />
        <span>새로운 버전이 있습니다.</span>
      </div>
      <div class="button-group">
        <button
            @click="update"
            class="update-button"
        >
          업데이트
        </button>
        <button
            @click="close"
            class="close-button"
        >
          닫기
        </button>
      </div>
    </div>
  </div>
</template>

<style scoped>
.update-prompt {
  position: fixed;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  max-width: 400px;
  background: white;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
  padding: 16px 20px;
}

.prompt-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.prompt-text {
  display: flex;
  align-items: center;
  gap: 8px;
}

.button-group {
  display: flex;
  gap: 8px;
}

.update-button {
  padding: 8px 16px;
  background-color: #15AF9A;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
}

.close-button {
  padding: 8px 16px;
  background-color: transparent;
  color: #666;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
}
</style>